if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        form: '[product-form="form"]',
        selectorsWrapper: '[product-form="selectors-wrapper"]',
        option: '[product-form="option"]',
        price: '[product-form="price"]',
        metaPrice: '.product__meta [data-variant-pricing] [data-variant-price]',
        mainSelect: '[product-form="main-select"]',
        mainSubmit: '[product-form="submit"]',
        submitText: '[product-form="button-text"]',
        message: '[product-form="availability-message"]',
        thumbsSlides: '.product-media__thumb-swiper-slide',
        expectedDeliveryDate: '.product-form__estimated-delivery [data-expected-delivery-date]',
        stickyBarImage: '.product__sticky-atc--featured-image',
        stickyBarPrice: '[product-form="sticky-bar-price"]',
        stickyBarSubmit: '[product-form="sticky-bar-button"]',
        mediaContainer: '.js-product-media',
      };
    }

    connectedCallback() {
      this.elements = {
        form: this.querySelector(this.selectors.form),
        selectorsWrapper: this.querySelector(this.selectors.selectorsWrapper),
        price: this.querySelector(this.selectors.price),
        metaPrice: document.querySelector(this.selectors.metaPrice),
        mainSelect: this.querySelector(this.selectors.mainSelect),
        mainSubmit: this.querySelector(this.selectors.mainSubmit),
        submitText: this.querySelector(this.selectors.submitText),
        message: this.querySelector(this.selectors.message),
        expectedDeliveryDate: this.querySelector(this.selectors.expectedDeliveryDate),
        stickyBarImage: this.querySelector(this.selectors.stickyBarImage),
        stickyBarPrice: this.querySelector(this.selectors.stickyBarPrice),
        stickyBarSubmit: document.querySelector(this.selectors.stickyBarSubmit),
        mediaContainer: document.querySelector(this.selectors.mediaContainer),
      };

      this.selectedVariant = this.elements.mainSelect.querySelector('option:checked');

      this.updateUrl();

      this.elements.selectorsWrapper?.addEventListener('input', this.onChange.bind(this));
      this.elements.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onChange() {
      this.updateSelectedVariant();

      if (!this.selectedVariant) {
        return;
      }

      this.updateUrl();
      this.updateFeaturedVariantImage();
      this.updatePrice();
      this.updateButtons();
      this.updateMessage();
      this.updateExpectedDeliveryDate();
      this.updateStickyBarProductId();
      this.updateStickyBarProductImage();
    }

    updateSelectedVariant() {
      const selectedOptions = [
        ...this.querySelectorAll(`${this.selectors.option}:checked`),
      ];

      const selectedVariant = [
        ...this.elements.mainSelect.querySelectorAll('option'),
      ].filter((option) => {
        const isMatch = selectedOptions.every((selectedOption) => {
          const order = selectedOption.getAttribute('data-order');
          return (
            option.getAttribute(`data-option-${order}`) === selectedOption.value
          );
        });

        if (isMatch) {
          this.elements.mainSelect.value = option.value;
        }

        return isMatch;
      });

      this.selectedVariant = selectedVariant[0];
    }

    updateUrl() {
      // if we are not calling this function on a PDP, skip it. sometimes a quickview may load in these components.
      if(!window.location.href.includes(`/products/`)) return;
      if (!this.dataset.urlUpdate) return;

      let urlParams = {};
      const locationUrl = window.location

      // allow existing params to persist in the URL. Code below will re-write any necessary values relating to the component.
      const params = new URLSearchParams(locationUrl.search);
      for (const [key, value] of params) {
        urlParams[key] = value;
      }

      urlParams.variant = this.selectedVariant.value;

      // create a new URL by combining the path and the urlParams
      let newUrl = `${locationUrl.pathname}?${new URLSearchParams(urlParams)}`;

      // console.log(`productOverview setUrl() history.replaceState() to ${newUrl}`);
      history.replaceState({}, '', newUrl);
    }

    updateFeaturedVariantImage() {
      const variantId = this.selectedVariant.getAttribute('data-variant-id');
      const variantTitle = this.selectedVariant.getAttribute('data-variant-title');

      this.elements.mediaContainer.dataset.variantId = variantId;
      this.elements.mediaContainer.dataset.variantTitle = variantTitle;

      console.log(this.selectedVariant);
    }

    updatePrice() {
      const newPrice = this.selectedVariant.getAttribute('data-price');
      const isUpdateEnabled = String(this.dataset.urlUpdate).toLowerCase() === "true";

      if (this.elements.price) {
        this.elements.price.innerHTML = newPrice;
      }
      
      if (isUpdateEnabled) {
        if(this.elements.metaPrice) {
          this.elements.metaPrice.innerHTML = newPrice;
        }
      }

      if (this.elements.stickyBarPrice) {
        this.elements.stickyBarPrice.innerHTML = newPrice;
      }
    }

    updateButtons() {
      const newPrice = this.selectedVariant.getAttribute('data-price');
      const mainSubmit = this.elements.mainSubmit;
      const stickyBarSubmit = this.elements.stickyBarSubmit;

      if (!mainSubmit) return;

      const isAvailable = !this.selectedVariant.hasAttribute('disabled');
      const availableString = mainSubmit.getAttribute('data-available');
      const unavailableString = mainSubmit.getAttribute('data-unavailable');
      let updateString = unavailableString;

      const isStickyValid =
        stickyBarSubmit &&
        stickyBarSubmit.closest('product-form') === this;

      if (isStickyValid) {
        if (isAvailable) {
          stickyBarSubmit.classList.remove('sold-out');
        } else {
          stickyBarSubmit.classList.add('sold-out');
        }
      }

      if (isAvailable) {
        mainSubmit.classList.remove('sold-out');
        updateString = availableString;
        mainSubmit.removeAttribute('disabled');
        if (isStickyValid) stickyBarSubmit.removeAttribute('disabled');
      } else {
        mainSubmit.classList.add('sold-out');
        mainSubmit.setAttribute('disabled', 'true');
        if (isStickyValid) stickyBarSubmit.setAttribute('disabled', 'true');
      }

      if (this.elements.submitText) {
        this.elements.submitText.innerHTML = updateString;
      } else {
        mainSubmit.innerHTML = `${updateString} <span data-button-price> • ${newPrice} </span>`;
      }

      if (isStickyValid) {
        stickyBarSubmit.innerHTML = `${updateString} <span data-button-price> • ${newPrice} </span>`;
      }
    }

    updateMessage() {
      if (!this.elements.message) {
        return
      }

      let message = this.elements.message.getAttribute('data-available');

      if (this.selectedVariant.hasAttribute('disabled')) {
        message = this.elements.message.getAttribute('data-unavailable');
      }

      this.elements.message.innerHTML = message
    }

    updateExpectedDeliveryDate() {
      const expectedDeliveryDate = parseInt(this.selectedVariant.getAttribute('data-expected-delivery'));
      const expectedDeliveryDateInitial = parseInt(this.selectedVariant.getAttribute('data-variant-delivery-initial'));

      function calculateDeliveryRange(businessDays = expectedDeliveryDate) {
        const formatDate = (date) =>
          date.toLocaleDateString("en-US", {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
          });

        const today = new Date();
        const startDate = new Date(today);
        const deliveryDate = new Date(today);
        deliveryDate.setDate(today.getDate() + expectedDeliveryDate);
        startDate.setDate(today.getDate() + expectedDeliveryDateInitial);

        let countedDays = 0;

        // while (countedDays < businessDays) {
        //   deliveryDate.setDate(deliveryDate.getDate() + 1);
        //   const dayOfWeek = deliveryDate.getDay();
        //   if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        //     countedDays++;
        //   }
        // }  
        return `${formatDate(startDate)} - ${formatDate(deliveryDate)}`;
      }

      if(this.elements.expectedDeliveryDate) {
        const estimatedDays = expectedDeliveryDate;
        this.elements.expectedDeliveryDate.innerHTML = calculateDeliveryRange(estimatedDays);
      }
    }

    updateStickyBarProductId() {
      if (!this.elements.stickyBarId) {
        return
      }

      this.elements.stickyBarId.value = this.selectedVariant.value;
    }

    updateStickyBarProductImage() {
      const newImage = this.selectedVariant.getAttribute('data-featured-image');

      if(newImage && this.elements.stickyBarImage) {
        this.elements.stickyBarImage.src = newImage;
        this.elements.stickyBarImage.srcset = newImage;
      }
    }

    onSubmit (e) {
      if (this.elements.form.dataset.type !== 'ajax-form') return;

      var _learnq = window._learnq || [];

      e.preventDefault()

      if (this.elements.mainSubmit) this.elements.mainSubmit.setAttribute('disabled', '')
      if (this.elements.stickyBarSubmit) this.elements.stickyBarSubmit.setAttribute('disabled', '')

      const formData = new FormData(this.elements.form);

      formData.append(
        'sections',
        'cart-drawer'
      )

      const config = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: `application/javascript` },
        body: formData
      }

      fetch('/cart/add', config)
      .then(res => res.json())
      .then(response => {
        _learnq.push(['track', 'Added to Cart', response]);
        const cartDrawerText = response.sections['cart-drawer']
        const html = new DOMParser().parseFromString(cartDrawerText, 'text/html');

        document.querySelector('.bag-link').innerHTML = `Bag (${html.querySelector('.cart-drawer__header').dataset.quantity})`
        document.querySelector('.cart-drawer__header').innerHTML = html.querySelector('.cart-drawer__header').innerHTML
        document.querySelector('.cart-drawer__items').innerHTML = html.querySelector('.cart-drawer__items').innerHTML
        document.querySelector('.js-cart-total').innerHTML = html.querySelector('.js-cart-total').innerHTML
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        document.querySelector('.navbar-toggler__cart').click()
        if (this.elements.mainSubmit) this.elements.mainSubmit.removeAttribute('disabled')
        if (this.elements.stickyBarSubmit) this.elements.stickyBarSubmit.removeAttribute('disabled')
      })
    }
  }
  customElements.define('product-form', ProductForm);
}